import { createApi } from '@reduxjs/toolkit/query/react';

import { INTERNAL_ERROR_STATUS_CODE } from '@/constants';
import { getCurrencyRatesApiRequestUrl, request } from '@/utils';

export const currencyRatesApi = createApi({
  reducerPath: 'currencyRates',
  endpoints: (builder) => ({
    getCurrencyRatesList: builder.query({
      queryFn: async ({ currency }) => {
        try {
          const response = await request(
            getCurrencyRatesApiRequestUrl({
              currency,
            })
          );

          return {
            data: response?.data || {},
          };
        } catch (error) {
          console.error('getCurrencyRatesList error:', error);

          return {
            error: {
              status: error?.response?.status || INTERNAL_ERROR_STATUS_CODE,
            },
          };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCurrencyRatesListQuery,
  util: { getRunningQueriesThunk: getRunningOperationPromisesCurrencyRates },
} = currencyRatesApi;

// export endpoints for use in SSR
export const { getCurrencyRatesList } = currencyRatesApi.endpoints;
